import { isSameSiteNoneCompatible } from 'should-send-same-site-none';

import { CookieOptions, remove, set } from './cookies';

export const testCookieName = 'cookietest';
export const testCookieValue = '1';
export const defaultOptions: CookieOptions = { partitioned: false };

type IsUnpartitionedThirdPartyCookieSupported = () => boolean;
export const isUnpartitionedThirdPartyCookieSupported: IsUnpartitionedThirdPartyCookieSupported = () => {
  const cookieOptions: CookieOptions = isSameSiteNoneCompatible(navigator.userAgent)
    ? { ...defaultOptions, sameSite: 'none' }
    : defaultOptions;

  try {
    set(testCookieName, testCookieValue, cookieOptions);
    remove(testCookieName, cookieOptions);

    return true;
  } catch (error) {
    return false;
  }
};
